<div class="prescription-container">
  <label class="toggle-label">
    Add Medicines
    <label class="toggle-switch">
      <input type="checkbox" [(ngModel)]="isPrintEnabled" />
      <span class="slider"></span>
    </label>
  </label>

  <table class="prescription-table">
    <thead>
      <tr>
        <th *ngFor="let header of tableHeaders">{{ header }}</th>
        <th>Delete</th>
      </tr>
    </thead>

    <tbody>
      <tr *ngFor="let row of prescriptionData; let i = index">
        <td>
          <select
            [(ngModel)]="row.type"
            (change)="selectedMedicineType($event.target.value)"
          >
            <option value="" disabled>Select type</option>
            <option *ngFor="let type of medicineTypes" [value]="type?.title">
              {{ type?.title }}
            </option>
          </select>
        </td>

        <td class="medicine-input-container">
          <input
            class="form-control"
            type="text"
            [(ngModel)]="row.medicine"
            (input)="filterMedicineSuggestions(row)"
            placeholder="Search medicine..."
          />

          <!-- Dropdown for medicine suggestions -->
          <ul
            class="medicine-suggestions"
            *ngIf="row.filteredMedicines?.length > 0"
          >
            <li
              *ngFor="let med of row.filteredMedicines"
              (click)="selectMedicine(row, med)"
            >
              {{ med.medicine }}
            </li>
          </ul>
        </td>
        <td>
          <input
            class="form-control"
            type="text"
            [(ngModel)]="row.content"
            placeholder="Enter Content"
          />
          <button
class="mic-button"
[class.recording]="isRecording"
(click)="toggleVoiceInput()"
title="Speak"
*ngIf="showVoiceInput"
>
<i class="fa fa-microphone"></i>
</button>
        </td>
        <td>
          <input
            class="form-control"
            type="text"
            [(ngModel)]="row.morning"
            (ngModelChange)="autoCalculateQuantity(row)"
            [attr.list]="'morningOptions'"
            placeholder="Enter or select morning dose"
          />
        
          <datalist id="morningOptions">
            <ng-container *ngFor="let data of intakeTimes">
              <ng-container *ngFor="let opt of data.options">
                <option
                  *ngIf="opt.time === 'morning' && data.medicineType === sel"
                  [value]="opt.value"
                ></option>
              </ng-container>
            </ng-container>
          </datalist>
        </td>
        
        <td>
          <input
            class="form-control"
            type="text"
            [(ngModel)]="row.afternoon"
            (ngModelChange)="autoCalculateQuantity(row)"
            [attr.list]="'afternoonOptions'"
            placeholder="Enter or select afternoon dose"
          />
        
          <datalist id="afternoonOptions">
            <ng-container *ngFor="let data of intakeTimes">
              <ng-container *ngFor="let opt of data.options">
                <option
                  *ngIf="opt.time === 'afternoon' && data.medicineType === sel"
                  [value]="opt.value"
                ></option>
              </ng-container>
            </ng-container>
          </datalist>
        </td>
        <td>
          <input
            class="form-control"
            type="text"
            [(ngModel)]="row.night"
            (ngModelChange)="autoCalculateQuantity(row)"
            [attr.list]="'nightOptions'"
            placeholder="Enter or select night dose"
          />
        
          <datalist id="nightOptions">
            <ng-container *ngFor="let data of intakeTimes">
              <ng-container *ngFor="let opt of data.options">
                <option
                  *ngIf="opt.time === 'night' && data.medicineType === sel"
                  [value]="opt.value"
                ></option>
              </ng-container>
            </ng-container>
          </datalist>
        </td>
        <td>
          <input
            class="form-control"
            type="text"
            [(ngModel)]="row.intakeTime"
            (ngModelChange)="autoCalculateQuantity(row)"
            [attr.list]="'intakeTimeOptions'"
            placeholder="Enter or select whenToTake dose"
          />
        
          <datalist id="intakeTimeOptions">
            <ng-container *ngFor="let data of intakeTimes">
              <ng-container *ngFor="let opt of data.options">
                <option
                  *ngIf="opt.time === 'whenToTake' && data.medicineType === sel"
                  [value]="opt.value"
                ></option>
              </ng-container>
            </ng-container>
          </datalist>
        </td>
        <td>
          <input
            class="form-control"
            type="number"
            [(ngModel)]="row.days"
            min="1"
            (ngModelChange)="autoCalculateQuantity(row)"
          />
        </td>
        <td>
          <input
            class="form-control"
            type="number"
            [(ngModel)]="row.quantity"
            min="1"
            (ngModelChange)="row.userModifiedQuantity = true"
          />
        </td>
        <td>
          <button (click)="removeRow(i)" class="delete-btn">Delete</button>
        </td>
      </tr>
    </tbody>
  </table>

  <button (click)="addRow()" class="add-btn">Add Medicine</button>
</div>
